import { createContext } from 'react';
import { parseISO } from 'date-fns';

/**
 * CurrentDateContext stores the "effective app date".
 * Default: new Date()
 *
 * Alternatively, a value can be provided. This allows components to have use
 * deterministic date, which is helpful for unit tests and Storybook.
 *
 * (MIGRATION NOTE: This context is SLIGHTLY DIFFERENT than AppDateContext
 * from my-nerdwallet. AppDateContext accepts strings; this context ONLY accepts Date.)
 */

interface CurrentDateContextValue {
  currentDate: Date;
  updateDate?: (newDate: Date) => void;
}

const CurrentDateContext = createContext<CurrentDateContextValue>({
  currentDate: new Date(),
  updateDate: () => {},
});

export default CurrentDateContext;

/**
 * Util to help with using CurrentDateContext.
 *
 * Example:
 * <CurrentDateContext.Provider value={{currentDate: isoToDate('2020-11-01')}}>
 */
export const isoToDate = (dateString: string) => parseISO(dateString);
